export default __webpack_public_path__ + "static/media/969.046f4e2a.png";